<app-header></app-header>
<app-public-register-container>
  <div class="iframe-container">
    <iframe
      src='https://bigin.zoho.com/crm/WebFormServeServlet?rid=268ff56f2522efb581442f82f19db8f1f1cee68299181161866ef94b9fc8fa36gid63ce056d420b38ddc8479e5bdba1a6ade2e3ad8952ff481b00c9a6033e88a06b'></iframe>
  </div>
</app-public-register-container>


<app-footer></app-footer>
